export const ALL_ADMIN_DEPARTMENTS = [
  'Sales',
  'Customer Support',
  'Clinical Support',
  'Technical Support',
  'Operations',
  'R&D',
  'Product',
  'DevOps',
] as const

export type AdminDepartment = (typeof ALL_ADMIN_DEPARTMENTS)[number]
